var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('BasePageHeader',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("訂單查詢")]},proxy:true}])}),_c('keep-alive',[_c(_vm.tabList[_vm.activeTab].component,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }